import { render, staticRenderFns } from "./JobPostCompanyDetail.vue?vue&type=template&id=464ceb1a&scoped=true&"
import script from "../../../services/company/job_post/job-post-company-detail.js?vue&type=script&lang=js&"
export * from "../../../services/company/job_post/job-post-company-detail.js?vue&type=script&lang=js&"
import style0 from "@/assets/css/job_details.css?vue&type=style&index=0&id=464ceb1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464ceb1a",
  null
  
)

export default component.exports